import { Button, Modal, ModalHeader, Typography } from "@joonapp/web-shared"
import { useShallow } from "zustand/react/shallow"

import { useCoachOverlayStore } from "./useCoachOverlay"
import useUnpauseConfirmationModalStore from "./useUnpauseConfirmationModalStore"
import { useUnpauseCoachSubscriptionMutation } from "../../../networking/coaching/mutations"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../util/analytics"

const UnpauseConfirmationModal = () => {
  const { isOpen, onClose } = useUnpauseConfirmationModalStore(
    useShallow((state) => ({ isOpen: state.isOpen, onClose: state.onClose }))
  )
  const { setCurrentOverlay } = useCoachOverlayStore(
    useShallow((state) => ({ setCurrentOverlay: state.setCurrentOverlay }))
  )
  const { mutateAsync: unpauseCoachSubscription, isLoading } =
    useUnpauseCoachSubscriptionMutation()

  const handleUnpause = async () => {
    await unpauseCoachSubscription()
    trackAnalyticEvent(ANALYTIC_EVENTS.UNPAUSE_COACHING_SUBSCRIPTION)
    setCurrentOverlay(null)
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{ width: "min(350px, 95vw)" }}
      animate
    >
      <ModalHeader title="Are you sure?" onClose={onClose} showBorderBottom />
      <div className="flex flex-col gap-4 p-6 pt-4 ">
        <Typography variant="bodyBold">
          Are you sure you want to unpause your subscription?
        </Typography>
        <div className="flex flex-row justify-between gap-4 items-center">
          <Button
            onClick={onClose}
            text="Back"
            fullWidth
            buttonType="secondary"
          />
          <Button
            text="Unpause"
            onClick={handleUnpause}
            fullWidth
            isLoading={isLoading}
          />
        </div>
      </div>
    </Modal>
  )
}

export default UnpauseConfirmationModal
